import Joi from 'joi-browser'


const automation = Joi.object().keys({
  properties: Joi.object().keys({
    days: Joi.number().positive(),
    weeks: Joi.number().positive(),
    // cronPattern: Joi.string(),
    description: Joi.string(),
    fromState: Joi.string().required(),
    moveToState: Joi.string().required(),
  }),
  lookupProps: Joi.object().keys({
		usecase: Joi.string().optional().allow('', null),
		clientApp: Joi.string().optional().allow('', null),
		itemType: Joi.string().optional().allow('', null),
	}),
  id: Joi.number(),
  tenantId: Joi.string().uuid(),
  automationType: Joi.string().allow(null, ''),
  title: Joi.string(),
   // used as namespace in i18n // both ui appName.featureName or appModule.featureName allowed in feature
  status: Joi.string().required(),
  createdBy: Joi.string().allow(null),
  updatedBy: Joi.string().allow(null),
  createdAt: Joi.date().allow(null),
  updatedAt: Joi.date().allow(null)
})

// These are the schemas of the return object from the api server
export const methodSchemas = {
  getAll: Joi.array().items(automation),
  getOne: automation,
  addItem: automation,
  editItem: automation,
  upsert: automation
}
export const collectionSchemas = {
  //  notes: note
}
export const entitySchema = automation